import React from "react";
import styles from "./help.styles.css";
import { CpTooltip, CpButton } from "canopy-styleguide!sofe";

export default function Help({  activeClientId }) {
  return (
    <>
      <div className={styles.spacer} />
      <CpTooltip text="View support library" position="bottom-right" className="cp-ml-8 cp-mr-16">
        <CpButton
          icon="help-circle-open-small"
          aria-label="View support library"
          anchor
          href="https://help.clientportal.com/"
          target="_blank"
          rel="noopener"
        />
      </CpTooltip>
    </>
  );
}
